import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import type { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import type { IconComponent, IconProps } from "./iconProps.utils";

// A FontAwesome icon drawn in the same box as the Material icons, so it sizes and colours like them.
export const faSvgIcon = (definition: IconDefinition, displayName: string): IconComponent => {
  const [width, height, , , path] = definition.icon;
  const paths = Array.isArray(path) ? path : [path];
  const Icon: React.FC<IconProps> = (props) => (
    <SvgIcon viewBox={`0 0 ${width} ${height}`} {...props}>
      {paths.map((d) => (
        <path key={d} d={d} />
      ))}
    </SvgIcon>
  );
  Icon.displayName = displayName;
  return Icon;
};
